import { Instagram, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import luxeLordsLogo from "@/assets/luxe-lords-logo-black.svg";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const Footer = () => {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.2 });

  return (
    <footer
      ref={ref}
      className={`pt-10 pb-24 lg:pt-16 border-t border-border transition-all duration-700 ease-out ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
      }`}
    >
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12 mb-8 lg:mb-12 text-center md:text-left">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-1">
              <img
                src={luxeLordsLogo}
                alt="Luxe Lords"
                className="h-5 lg:h-6 w-auto"
              />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs mx-auto md:mx-0">
              Premium Vegan leather perfume atomizers for the discerning traveler.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-col items-center md:items-start gap-1.5">
            <p className="text-luxury text-foreground mb-0.5" role="heading" aria-level={3}>Navigate</p>
            <a
              href="/#collection"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Collection
            </a>
            <a
              href="/#craft"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Our Craft
            </a>
            <a
              href="/#story"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Story
            </a>
          </div>

          {/* Contact */}
          <div>
            <p className="text-luxury text-foreground mb-2.5" role="heading" aria-level={3}>Connect</p>
            <div className="flex gap-3 justify-center md:justify-start">
              <a
                href="https://www.instagram.com/luxelordsofficial" target="_blank" rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center text-foreground hover:bg-primary hover:text-primary-foreground transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="mailto:info@luxelords.com"
                className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center text-foreground hover:bg-primary hover:text-primary-foreground transition-colors duration-300"
                aria-label="Email"
              >
                <Mail size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-6 border-t border-border flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-xs text-muted-foreground">
            © 2026 Luxe Lords™. All rights reserved.
          </p>
          <div className="flex flex-wrap gap-x-6 gap-y-2 justify-center">
            <Link
              to="/privacy"
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacy
            </Link>
            <Link
              to="/cookies"
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              Cookies
            </Link>
            <Link
              to="/terms"
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              Terms
            </Link>
            <Link
              to="/contact"
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
